import { action } from 'satcheljs';
import { Settings } from '../schema/ScenarioSettings';

export const loadWorkloadScenarioSettings = action(
    'LOAD_WORKLOAD_SCENARIO_SETTINGS',
    (accountSmtpAddress: string = null) => ({
        accountSmtpAddress,
    })
);

export const workloadScenarioSettingsLoaded = action(
    'WORKLOAD_SCENARIO_SETTINGS_LOADED',
    (settings: Settings, accountSmtpAddress: string) => ({
        settings: settings,
        accountSmtpAddress: accountSmtpAddress,
    })
);

export const loadingWorkloadScenarioSettingsFailed = action(
    'LOADING_WORKLOAD_SCENARIO_SETTINGS_FAILED',
    (accountSmtpAddress: string) => ({
        accountSmtpAddress,
    })
);
